import { Action, ActionContext } from 'actions';
import { downloadCommentAttachments } from './downloadCommentAttachments';

export const commentActions = (context: ActionContext) =>
  ({
    downloadAttachments: downloadCommentAttachments(context),
  } satisfies Record<string, Action>);
